import styled from 'styled-components'

const Columns = styled.div`
  display: flex;
  padding: 20px 30px 7px 30px;
`

const Column = styled.div`
  margin-right: 30px;
  width: 230px;
`

export const s = { Columns, Column }
